import api from './api';
import {
  BatteryReview,
  ReviewListResponse,
  CreateReviewRequest,
  PaginationParams,
} from '../types/api';

const parseReview = (review: BatteryReview): BatteryReview => ({
  ...review,
  images: Array.isArray(review.images) ? review.images : [],
  createdAt: new Date(review.createdAt),
  updatedAt: new Date(review.updatedAt),
});

/**
 * Serviço de Avaliações
 */
const reviewService = {
  /**
   * Lista avaliações de uma bateria
   */
  async listByBattery(
    batteryId: string,
    params?: {
      rating?: number;
      sortBy?: string;
      sortOrder?: 'asc' | 'desc';
    } & PaginationParams
  ): Promise<ReviewListResponse> {
    const response = await api.get<{
      success: boolean;
      data: ReviewListResponse;
    }>(`/batteries/${batteryId}/reviews`, {
      params,
    });

    const raw = response.data.data;

    return {
      ...raw,
      reviews: raw.reviews.map(parseReview),
    };
  },

  /**
   * Cria nova avaliação
   */
  async create(
    batteryId: string,
    data: CreateReviewRequest
  ): Promise<{ review: BatteryReview }> {
    const response = await api.post<{
      success: boolean;
      data: { review: BatteryReview };
    }>(`/batteries/${batteryId}/reviews`, data);

    return {
      review: parseReview(response.data.data.review),
    };
  },

  /**
   * Marca avaliação como útil
   */
  async markHelpful(
    reviewId: string,
    helpful: boolean
  ): Promise<{ review: BatteryReview }> {
    const response = await api.put<{
      success: boolean;
      data: { review: BatteryReview };
    }>(`/reviews/${reviewId}/helpful`, {
      helpful,
    });

    return {
      review: parseReview(response.data.data.review),
    };
  },
};

export default reviewService;

